let customerChild = [
    {
        path: '',
        component: () => import(/* webpackChunkName: 'lco-customer */ '@/components/customer/customerCorner/CustomerCorner.vue'),
        name: 'customer',
        meta: {
            title: 'Home Page - Example App'
        }   
    },
    {
        path: 'createcustomer',
        component: () =>
            import ( /* webpackChunkName: 'lco-createcustomer */ '@/components/customer/createCustomer/CreateCustomer.vue'),
        name: 'createcustomer'
    },
    {
        path: 'ticket',
        component: () => import(/* webpackChunkName: 'lco-ticket */ '@/components/customer/ticket/Ticket.vue'),
        name: 'ticket',
        meta: {
            title: 'Home Page - Example App'
        }
    },
    {
        path: 'refund',
        component: () => import(/* webpackChunkName: 'lco-refund */ '@/components/customer/refund/Refund.vue'),
        name: 'refund'
    },
    {
        path: 'customerSelection',
        component: () => import(/* webpackChunkName: 'lco-customerSelection */ '@/components/customer/customerSelection/CustomerSelection.vue'),
        name: 'customerSelection'
    },
    {
        path: 'proformainvoice',
        component: () => import(/* webpackChunkName: 'lco-proformainvoice */ '@/components/customer/proformaInvoice/ProformaInvoice.vue'),
        name: 'proformainvoice'
    },
    {
        path: 'subscriberlist',
        component: () => import(/* webpackChunkName: 'lco-subscriberlist */ '@/components/customer/subscriberList/SubscriberList.vue'),
        name: 'subscriberlist'
    },
    {
        path: 'history',
        component: () => import(/* webpackChunkName: 'lco-history */ '@/components/customer/history/History.vue'),
        name: 'history'
    }
    
]
let deviceChild = [
    {
        path: '',
        component: () => import(/* webpackChunkName: 'lco-retrack */ '@/components/device/retrack/Retrack.vue'),
        name: 'device'
    },
    {
        path: 'retrack-deactive',
        component: () => import(/* webpackChunkName: 'lco-retrackDeactive */ '@/components/device/retrackDeactive/RetrackDeactive.vue'),
        name: 'retrack-deactive'
    },
    {
        path: 'replacement',
        component: () => import(/* webpackChunkName: 'lco-replacement */ '@/components/device/replacement/Replacement.vue'),
        name: 'replacement'
    },
    {
        path: 'osd',
        component: () => import(/* webpackChunkName: 'lco-osd */ '@/components/device/osd/Osd.vue'),
        name: 'osd'
    },
    {
        path: 'purchasestb',
        component: () => import(/* webpackChunkName: 'lco-purchasestb */ '@/components/device/payForBox/PayForBox.vue'),
        name: 'purchasestb'
    },
    {
        path: 'andriodrequest',
        component: () => import(/* webpackChunkName: 'lco-andriodrequest */ '@/components/device/androidRequest/AndroidRequest.vue'),
        name: 'andriodrequest'
    },
    {
        path: 'sms',
        component: () => import(/* webpackChunkName: 'lco-customer */ '@/components/device/sms/Sms.vue'),
        name: 'sms'
    },
    {
        path: 'stbreturn',
        component: () => import(/* webpackChunkName: 'lco-customer */ '@/components/device/stbReturn/STBReturn.vue'),
        name: 'stbreturn'
    },
    {
        path: 'trackstb',
        component: () => import(/* webpackChunkName: 'lco-track-stb */ '@/components/device/trackSTB/TrackSTB.vue'),
        name: 'trackstb'
    },
    {
        path: 'statusreport',
        component: () => import(/* webpackChunkName: 'lco-track-stb */ '@/components/device/deviceStatusReport/DeviceStatusReport.vue'),
        name: 'statusreport'
    },
]
let productChild = [
    {
        path: '',
        component: () => import(/* webpackChunkName: 'lco-product-addpacks */ '@/components/product/addpacks/AddPacks.vue'),
        name: 'product'
    },
    {
        path: 'renew',
        component: () => import(/* webpackChunkName: 'lco-product-renew */ '@/components/product/renew/RenewMain.vue'),
        name: 'renew'
    },
    {
        path: 'modify',
        component: () => import(/* webpackChunkName: 'lco-product-modify */ '@/components/product/modify/Modify.vue'),
        name: 'modify'
    },
    {
        path: 'planmaster',
        component: () => import(/* webpackChunkName: 'lco-product-planmaster */ '@/components/product/planMaster/PlanMaster.vue'),
        name: 'planmaster'
    },
    {
        path: 'knowyourpacks',
        component: () => import ( /* webpackChunkName: 'lco-product-Know-Your-Packs */ '@/components/product/knowYourPacks/KnowYourPacks.vue'),
        name: 'knowyourpacks'
    },
    {
        path: 'discontinuedpacks',
        component: () => import(/* webpackChunkName: 'lco-product-discontinuedpacks */ '@/components/product/discontinuedPacks/DiscontinuedPacks.vue'),
        name: 'discontinuedpacks'
    },
    {
        path: 'onedigitalpacks',
        component: () => import(/* webpackChunkName: 'lco-product-oneDigitalPacks */ '@/components/product/oneDigitalPacks/OneDigitalPacks.vue'),
        name: 'onedigitalpacks'
    },
    {
        path: 'singleactivation',
        component: () => import(/* webpackChunkName: 'lco-product-oneDigitalPacks-singleActivation */ '@/components/product/oneDigitalPacks/singleActivation/SingleActivation.vue'),
        name: 'singleactivation'
    },
    {
        path: 'combopacks',
        component: () => import(/* webpackChunkName: 'lco-product-combopacks */ '@/components/product/comboPacks/ComboPack.vue'),
        name: 'combopacks'
    },
    {
        path: 'bulkcomboactivation',
        component: () => import(/* webpackChunkName: 'lco-product-bulkcomboactivation */ '@/components/product/comboPacks/bulkActivation.vue'),
        name: 'bulkcomboactivation'
    },
]
let reportChild = [
    {
        path: '',
        component: () => import(/* webpackChunkName: 'lco-report-activation */ '@/components/report/activation/Activation.vue'),
        name: 'report'
    },
    {
        path: 'expiry',
        component: () => import(/* webpackChunkName: 'lco-report-expiry */ '@/components/report/expiry/Expiry.vue'),
        name: 'reportExpiry'
    },
    {
        path: 'expired',
        component: () => import(/* webpackChunkName: 'lco-report-expired */ '@/components/report/expired/Expired.vue'),
        name: 'reportExpired'
    },
    {
        path: 'jobmonitor',
        component: () => import(/* webpackChunkName: 'lco-report-jobMoniter */ '@/components/report/jobMoniter/JobMoniter.vue'),
        name: 'reportJobMonitor'
    },
    {
        path: 'bills',
        component: () => import(/* webpackChunkName: 'lco-report-bill */ '@/components/report/bills/Bills.vue'),
        name: 'reportBills'
    },
    {
        path: 'refund',
        component: () => import(/* webpackChunkName: 'lco-report-refund */ '@/components/report/refund/Refund.vue'),
        name: 'reportRefund'
    },
    {
        path: 'stbreplacement',
        component: () => import(/* webpackChunkName: 'lco-report-stbreplacement */ '@/components/report/stbReplacement/StbReplacement.vue'),
        name: 'reportStbreplacement'
    },
    {
        path: 'ekyc',
        component: () => import(/* webpackChunkName: 'lco-report-ekyc */ '@/components/report/ekyc/EKYC.vue'),
        name: 'reportEKYC'
    },
    {
        path: 'schedule/:id',
        component: () => import(/* webpackChunkName: 'lco-report-schedule */ '@/components/report/schedule/Schedule.vue'),
        name: 'reportSchedule'
    },
    {
        path: 'payment',
        component: () => import(/* webpackChunkName: 'lco-report-payment */ '@/components/report/payment/Payment.vue'),
        name: 'reportPayment'
    },
    {
        path: 'modifiedCustomer',
        component: () => import(/* webpackChunkName: 'lco-report-bill */ '@/components/report/modifiedCustomer/ModifiedCustomer.vue'),
        name: 'reportModifiedCustomer'
    },
    {
        path: 'accountstatement',
        component: () => import(/* webpackChunkName: 'lco-report-accountstatement */ '@/components/report/accountStatement/AccountStatement.vue'),
        name: 'reportaccountstatement'
    },
    {
        path: 'channellineupgen1',
        component: () => import(/* webpackChunkName: 'lco-report-channellineupgen1 */ '@/components/report/channelLineUpGen1/ChannelLineUpGen1.vue'),
        name: 'channellineupgen1'
    },
    {
        path: 'channellineupgen2',
        component: () => import(/* webpackChunkName: 'lco-report-channellineupgen2 */ '@/components/report/channelLineUpGen2/ChannelLineUpGen2.vue'),
        name: 'channellineupgen2'
    },
    {
        path: 'walletdebit',
        component: () => import(/* webpackChunkName: 'lco-report-walletDebit */ '@/components/report/walletDebit/WalletDebit.vue'),
        name: 'walletdebit'
    },
    {
        path: 'consolidatedreport',
        component: () => import(/* webpackChunkName: 'lco-report-consolidatedreport */ '@/components/report/consolidated/Consolidated.vue'),
        name: 'consolidatedreport'
    },
    {
        path: 'dcrefund',
        component: () => import(/* webpackChunkName: lco-report-dc-refund*/ '@/components/report/dcRefund/DCRefund.vue'),
        name: 'dcrefund'
    }
]

let menuChildren = [
    {
        path: '', 
        component: () => import(/* webpackChunkName: 'lco-dashboard */ '@/components/dashboard/Dashboard.vue'),
        name: 'dashboard'
    },
    {
        path: 'alert',
        component: () => import(/* webpackChunkName: 'lco-alert */ '@/components/alert/Alert.vue'),
        name: 'alert'
    },
    {
        path: 'bigbonanza',
        component: () => import(/* webpackChunkName: 'lco-alert-bigbonanza */ '@/components/alert/offers/bigBonanza/BigBonanza.vue'),
        name: 'bigbonanza'
    },
    {
        path: 'bigbonanzalocation',
        component: () => import(/* webpackChunkName: 'lco-alert-bigbonanza-bigbonanzalocation */ '@/components/alert/offers/bigBonanza/BigBonanzaLocation.vue'),
        name: 'bigbonanzalocation'
    },
    {
        path: 'quiz',
        component: () => import(/* webpackChunkName: 'lco-alert-quiz */ '@/components/alert/quiz/quiz.vue'),
        name: 'quiz'
    },
    {
        path: 'thankyou',
        component: () => import(/* webpackChunkName: 'lco-alert-thankyou */ '@/components//alert/quiz/thankyou.vue'),
        name: 'thankyou'
    },
    {
        path: 'device',
        component: () => import(/* webpackChunkName: 'lco-alert */ '@/components/device/DeviceMain.vue'),
        children: deviceChild
    },
    {
        path: 'customer',
        component: () => import(/* webpackChunkName: 'lco-customer */ '@/components/customer/CustomerMain.vue'),
        children: customerChild
    },
    {
        path: 'download',
        component: () => import(/* webpackChunkName: 'lco-product */ '@/components/download/Download.vue'),
        name: 'download'
    },
    {
        path: 'report',
        component: () => import(/* webpackChunkName: 'lco-customer */ '@/components/report/Report.vue'),
        children: reportChild
    },
    {
        path: 'product',
        component: () => import(/* webpackChunkName: 'lco-product */ '@/components/product/Product.vue'),
        children: productChild
    },
    {
        path: 'checkout',
        component: () => import(/* webpackChunkName: 'lco-product-checkout */ '@/components/checkout/Subscribe.vue'),
        name: 'checkout'
    },
    {
        path: 'generatenewinvoice',
        component: () => import(/* webpackChunkName: 'lco-customer-generateinvoice */ '@/components/customer/proformaInvoice/generateInvoice/GenerateInvoice.vue'),
        name: 'generatenewinvoice'
    },
    {
        path: 'invoicecheckout',
        component: () => import(/* webpackChunkName: 'lco-invoice-invoicecheckout */ '@/components/customer/proformaInvoice/checkout/Subscribe.vue'),
        name: 'invoicecheckout'
    },
    {
        path: 'topup',
        component: () => import(/* webpackChunkName: 'lco-header-topup */ '@/components/header/TopUp.vue'),
        name: 'topup'
    },
    {
        path: 'subuser',
        component: () => import(/* webpackChunkName: 'lco-header-subuser */ '@/components/header/subuser/Subuser.vue'),
        name: 'subuser'
    },
    {
        path: 'subscribeddetails',
        component: () => import(/* webpackChunkName: 'lco-header-subuser */ '@/components/checkout/SubscribedDetails.vue'),
        name: 'subuscribeddetails'
    },
    {
        path: '/helpvideos',
        component: () => import(/* webpackChunkName: 'lco-helpvideos */ '@/components/helpVideos/HelpVideos.vue'),
        name: 'helpvideos'
    },
    {
        path: '/videoplayer',
        component: () => import(/* webpackChunkName: 'lco-videoPlayer */ '@/components/videoPlayer/VideoPlayer.vue'),
        name: 'videoplayer'
    },
    {
        path: '/mibnotfications',
        component: () => import(/* webpackChunkName: 'lco-mibnotfications */ '@/components/mibNotification/MIBNotification.vue'),
        name: 'mibnotfications'
    },
    {
        path: "/description",
        component: () => import(/* webpackChunkName: 'lco-description */ "@/components/description/Description.vue"),
        name: "description"
    },
]

export const routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: 'lco-home */ '@/components/login/NewLogin.vue'),
        name: 'login'
    },
    {
        path: '/contactverify',
        component: () => import(/* webpackChunkName: 'lco-contactverify */ '@/components/contactVerify/ContactVerify.vue'),
        name: 'contactverify'
    },
    {
        path: '/nrnverify',
        component: () => import(/* webpackChunkName: 'lco-nrnverify */ '@/components/mibNotification/nrnVerify.vue'),
        name: 'nrnverify'
    },
    {
        path: '/maintenance',
        component: () => import(/* webpackChunkName: 'lco-maintenance */ '@/components/maintenance/Maintenance.vue'),
        name: 'maintenance'
    },
    {
        path: '/covid19awareness/',
        component: () => import(/* webpackChunkName: 'lco-newportal */ '@/components/newportal/Newportal.vue'),
        name: 'covid19awareness'
    },
    {
        path: '/covid19awareness/:id',
        component: () => import(/* webpackChunkName: 'lco-newportal */ '@/components/newportal/redirectId.vue'),
        name: 'covid19awarenessid'
    },
    {
        path: '/maintenancelogin',
        component: () => import(/* webpackChunkName: 'lco-maintenancelogin */ '@/components/maintenance/Login.vue'),
        name: 'maintenancelogin'
    },
    {
        path: '/register',
        component: () => import(/* webpackChunkName: 'lco-register */ '@/components/login/Register.vue'),
        name: 'register'
    },
    {
        path: '/changepassword',
        component: () => import(/* webpackChunkName: 'lco-change-password */ '@/components/login/ChangePassword.vue'),
        name: 'changepassword'
    },
    {
        path: '/lcoportal',
        component: () => import(/* webpackChunkName: 'lco-init */ '@/components/init/NewInitView.vue'),
        children: menuChildren,
        name: 'home'
    },
    {
        path: '/support',
        component: () => import(/* webpackChunkName: 'lco-header-subuser */ '@/components/footer/Support.vue'),
        name: 'support'
    },
    {
        path: '/helpcenter',
        component: () => import(/* webpackChunkName: 'lco-header-subuser */ '@/components/footer/HelpCenter.vue'),
        name: 'helpcenter'
    },
    {
        path: '/privacy',
        component: () => import(/* webpackChunkName: 'lco-header-subuser */ '@/components/footer/Privacy.vue'),
        name: 'privacy'
    },
    {
        path: '/termsandconditions',
        component: () => import(/* webpackChunkName: 'lco-header-subuser */ '@/components/footer/TermsForServices.vue'),
        name: 'termsandconditions'
    },
    {
        path: '/paymentstatuscheck',
        component: () => import(/* webpackChunkName: 'lco-paymentstatuscheck */ '@/components/verifyPaymentStatus/VerifyPaymentStatus.vue'),
        name: 'paymentstatuscheck'
    },
    {
        path: '/paymentconfirm/:id',
        component: () => import(/* webpackChunkName: 'lco-paymentconfirm */ '@/components/verifyPaymentStatus/PaymentConfirm.vue'),
        name: 'paymentconfirm'
    },
    {
        path: '/supportlogin',
        component: () => import(/* webpackChunkName: 'lco-Support -Login */ '@/components/login/SupportLogin.vue'),
        name: 'supportlogin'
    },
]


// WEBPACK FOOTER //
// ./src/router/routes.js